import { render } from "./IconCheck.vue?vue&type=template&id=9a748b60"
import script from "./IconCheck.vue?vue&type=script&lang=ts"
export * from "./IconCheck.vue?vue&type=script&lang=ts"
script.render = render

export default script